import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { GET_PROCESS, EXECUTE_PROCESS } from "../actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";


import {
  getProcessSuccess,
  getProcessError,
  executeProcessSuccess,
  executeProcessError,
} from "./actions";

export function* watchGetProcess() {
  yield takeEvery(GET_PROCESS, getProcess);
}

export function* watchExecuteProcess() {
  yield takeEvery(EXECUTE_PROCESS, executeProcess);
}

const getProcessAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get(
      `/Processes/${payload.processId}`, getActivityHeadersUpdated(payload)
    );
    if (dataReturned.data) {
      return {
        process: dataReturned.data,
        message: null,
      };
    }
    return { message: "Get process failed." };
  } catch (error) {
    return {
      message: "Failed to get process. ",
    };
  }
};

function* getProcess({ payload }) {
  try {
    const returnedData = yield call(getProcessAsync, payload);
    if (!returnedData.message) {
      yield put(
        getProcessSuccess({
          process: returnedData.process,
        })
      );
    } else {
      yield put(getProcessError(returnedData.message));
    }
  } catch (error) {
    yield put(getProcessError(error));
  }
}

const executeProcessAsync = async (payload) => {
  try {
    const dataReturned = await centralApiAxios.get(
      `/processes/${payload.processId}/executes`
    );
    if (dataReturned.data) {
      return {
        successMessage: "Process execution is in progress.",
        message: null,
      };
    }
    return { message: "Process execution failed." };
  } catch (error) {
    return {
      message: "Process execution failed. ",
    };
  }
};

function* executeProcess({ payload }) {
  try {
    const returnedData = yield call(executeProcessAsync, payload);
    if (!returnedData.message) {
      yield put(executeProcessSuccess(returnedData.successMessage));
    } else {
      yield put(executeProcessError(returnedData.message));
    }
  } catch (error) {
    yield put(executeProcessError(error));
  }
}

export default function* rootSaga() {
  yield all([fork(watchGetProcess), fork(watchExecuteProcess)]);
}
